export default __webpack_public_path__ + "media/images/picnic-splat-ccffe5bbc0b71429b9f24f49fa77da0d.svg";